export default "__VITE_ASSET__CJnypqmd__"